// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a97ed31e","453":"bb9e94b4","455":"2b88c5ee"}[chunkId] + ".chunk.js";
};